// [CurveBeam] - [BoneVue]

export class DicomSr {
  sourceSeriesUID: string;
  displaySetInstanceUID: string;
}
